export function unique<T> (input: Array<T>): Array<T> {
    return [...new Set(input)];
}

export function uniqueBy<T, K extends keyof T> (input: Array<T>, propName: K): Array<T> {
    const seen = new Map();
    return input.filter(item => {
        const propValue = item[propName];
        if (seen.has(propValue)) {
            return false;
        }
        seen.set(propValue, true);
        return true;
    });
}
